import { SET_USER_DETAILS } from '../../constants';
import { IReduxAction } from '../../interfaces';

import { getUserProfileData } from '../../../services';
import {
  updateLeaderProfileData,
  updateUserProfileData,
} from '../../../services/user_profiles/service';

export const loadUserDetails = async (userId: string): Promise<IReduxAction> => {
  return Promise.resolve({
    type: SET_USER_DETAILS,
    payload: await getUserProfileData(userId),
  });
};

export const updateLeaderProfile = async (currUser: any, values: any) => {
  updateLeaderProfileData({
    ...values,
    uid: currUser.uid,
  })
    .then(() => {
      return Promise.resolve(true);
    })
    .catch(() => {
      return Promise.reject('Error while updating Profile');
    });
};

export const updateUserProfile = async (currUser: any, values: any) => {
  updateUserProfileData({
    ...values,
    uid: currUser.uid,
  })
    .then(() => {
      return Promise.resolve(true);
    })
    .catch(() => {
      return Promise.reject('Error while updating Profile');
    });
};
